import { apiClient } from './client';

const getAuthHeaders = () => {
  const token = localStorage.getItem('token') || sessionStorage.getItem('token');
  return { Authorization: `Bearer ${token}` };
};

export const getSettings = async () => {
  const response = await apiClient.get('/settings', {
    headers: getAuthHeaders()
  });
  return response.data;
};

export const updateSetting = async (key, value) => {
  const response = await apiClient.put(`/settings/${key}`, { value }, {
    headers: getAuthHeaders()
  });
  return response.data;
};